import { h } from 'preact';

export const renderPreviewModeNotice = (target, renderer) => {
  const Widget = () => {
    const css = (
      <style>{`.beans-preview-notice-container {position: fixed;right: 5%;bottom: 0;z-index: 324568560;font-family: Montserrat, sans-serif;font-size: 13px;font-weight: 700;background: #fcdfb9;border-radius: 4px 4px 0 0;}.beans-preview-notice-content, .beans-preview-notice-exit-button, .beans-preview-notice-content div {display: flex;flex-direction: row;align-items: center;}.beans-preview-notice-content {padding-left: 8px;}.beans-preview-notice-container .beans-logo, .beans-preview-notice-container .beans-logo ~ div {margin-right: 6px;}.beans-preview-notice-exit-button {padding: 10px;cursor: pointer;background: rgba(0, 0, 0, 0.1);border-radius: 0 4px 0 0;}.beans-preview-notice-exit-button:hover {background: rgba(0, 0, 0, 0.25);}`}</style>
    );
    return (
      <div className="beans-preview-notice-container">
        {css}
        <div className="beans-preview-notice-content">
          <div>
            <svg
              className="beans-logo"
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.4796 18.9123C15.1142 18.9123 18.8713 15.1552 18.8713 10.5206C18.8713 8.74246 18.3182 7.09351 17.3748 5.73634C17.1132 6.40437 16.7392 7.1045 16.1126 7.81449C15.0478 9.02114 13.3083 10.2007 10.3078 11.4231C7.42598 12.5969 6.2028 13.666 5.59249 14.5634C5.28581 15.0142 5.11178 15.4534 4.96872 15.909C4.928 16.0385 4.88653 16.1828 4.84285 16.3345C4.81313 16.4378 4.78245 16.5445 4.75034 16.6523C6.2501 18.0542 8.26469 18.9123 10.4796 18.9123Z"
                fill="black"
              />
              <path
                d="M3.60944 15.3406C3.7721 14.8452 3.99449 14.3027 4.37867 13.7377C5.217 12.5052 6.73741 11.2923 9.75404 10.0636C12.6518 8.88314 14.1582 7.81066 15.0119 6.84322C15.7166 6.04474 16.0134 5.28057 16.2638 4.44081C14.7585 3.00823 12.7217 2.12891 10.4796 2.12891C5.84499 2.12891 2.08789 5.886 2.08789 10.5206C2.08789 12.3144 2.65079 13.9767 3.60944 15.3406Z"
                fill="black"
              />
            </svg>
            <div>Beans preview mode</div>
          </div>
          <div onClick={() => window.Beans3.previewSession.exit()} className="beans-preview-notice-exit-button">
            <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.8889 1.56958L1.0002 11.4587M10.8891 11.4585L1 1.56978" stroke="black" strokeWidth="2" />
            </svg>
          </div>
        </div>
      </div>
    );
  };

  renderer(<Widget />, target);
};

export const renderStagingEnvBadge = (target, renderer) => {
  const Widget = () => {
    const css = (
      <style>{`.beans-staging-notice-container {position: fixed;right: 20%;bottom: 0;z-index: 324568560;font-family: Montserrat, sans-serif;font-size: 13px;font-weight: 700;background-color: #e32e2e;color: white;padding: 6px 8px;border-radius: 4px 4px 0 0;}.beans-staging-notice-content, .beans-staging-notice-exit-button, .beans-staging-notice-content div {display: flex;flex-direction: row;align-items: center;}.beans-staging-notice-content {padding-left: 0;}.beans-staging-notice-container .beans-logo, .beans-staging-notice-container .beans-logo ~ div {margin-right: 6px;}.beans-staging-notice-exit-button {padding: 10px;cursor: pointer;background: rgba(0, 0, 0, 0.1);border-radius: 0 4px 0 0;}`}</style>
    );
    return (
      <div className="beans-staging-notice-container">
        {css}
        <div className="beans-staging-notice-content">
          <div>
            <svg
              className="beans-logo"
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.4796 18.9123C15.1142 18.9123 18.8713 15.1552 18.8713 10.5206C18.8713 8.74246 18.3182 7.09351 17.3748 5.73634C17.1132 6.40437 16.7392 7.1045 16.1126 7.81449C15.0478 9.02114 13.3083 10.2007 10.3078 11.4231C7.42598 12.5969 6.2028 13.666 5.59249 14.5634C5.28581 15.0142 5.11178 15.4534 4.96872 15.909C4.928 16.0385 4.88653 16.1828 4.84285 16.3345C4.81313 16.4378 4.78245 16.5445 4.75034 16.6523C6.2501 18.0542 8.26469 18.9123 10.4796 18.9123Z"
                fill="black"
              />
              <path
                d="M3.60944 15.3406C3.7721 14.8452 3.99449 14.3027 4.37867 13.7377C5.217 12.5052 6.73741 11.2923 9.75404 10.0636C12.6518 8.88314 14.1582 7.81066 15.0119 6.84322C15.7166 6.04474 16.0134 5.28057 16.2638 4.44081C14.7585 3.00823 12.7217 2.12891 10.4796 2.12891C5.84499 2.12891 2.08789 5.886 2.08789 10.5206C2.08789 12.3144 2.65079 13.9767 3.60944 15.3406Z"
                fill="black"
              />
            </svg>
            <div>Beans staging version</div>
          </div>
        </div>
      </div>
    );
  };

  renderer(<Widget />, target);
};
